import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-lib3',
  template: `
    <p>
      lib3 works!
    </p>
  `,
  styles: []
})
export class Lib3Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
